/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApiHeaders} from './headers';
import {RestResponse} from '../model';

@Injectable()
export class FileProvider {

  constructor(
    private http: HttpClient
  ) {}

  uploadDoc(formData: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(environment.API_URL + '/api/file/doc', formData, ApiHeaders.getOptions());
  }

  uploadAvatar(imageFile: string): Observable<RestResponse> {
    return this.http.post<RestResponse>(`${environment.API_URL}/api/file/avatar`,
      {image: imageFile}, ApiHeaders.getOptions());
  }

  getAvatar(avatarUrl: string): Observable<any> {
    return this.http
      .get(`${environment.API_URL}/api/file/users${avatarUrl}`, { observe: 'response', responseType: 'blob' });
  }
}
